/* Blue Collar Pack Co. "Ask the Pack" chat v2. Runs in the browser, no outside services. */
(function (G) {
  'use strict';

  /* =================== CORE (pure logic, unit-tested in node) =================== */
  var SYN = {
    ship: 'ship shipping shipped ships deliver delivery delivered post postage mail send sent',
    arrive: 'arrive arrival arrives receive',
    time: 'long fast quick soon days weeks eta when',
    cost: 'cost costs much expensive cheap',
    price: 'price prices priced pricing',
    world: 'worldwide world everywhere abroad overseas global',
    international: 'international internationally',
    country: 'country countries',
    canada: 'canada canadian',
    australia: 'australia aussie',
    uk: 'uk england britain',
    europe: 'europe eu european germany france spain italy',
    free: 'free',
    customs: 'customs import',
    duty: 'duty duties',
    tax: 'tax taxes vat',
    track: 'track tracking tracker',
    package: 'package packages parcel box',
    split: 'separate multiple two split',
    order: 'order orders ordered purchase',
    status: 'status',
    cancel: 'cancel cancellation',
    change: 'change edit modify update',
    address: 'address',
    wrong: 'wrong mistake incorrect',
    return: 'return returns returning',
    refund: 'refund refunds reimburse',
    policy: 'policy policies rules',
    exchange: 'exchange swap replace replacement',
    damage: 'damage damaged',
    misprint: 'misprint misprinted faded smeared',
    defect: 'defect defective flaw hole stitching',
    broken: 'broken ripped torn',
    lost: 'lost missing never stolen',
    size: 'size sizes sizing measurements measurement chart guide xs xl xxl xxxl 2xl 3xl 4xl 5xl 7xl large medium',
    fit: 'fit fits fitting runs true',
    big: 'big bigger tall loose oversized',
    small: 'small smaller tight snug',
    tee: 'tee tees shirt shirts tshirt tshirts t-shirt t-shirts top tops',
    hoodie: 'hoodie hoodies hoody hoodys sweatshirt sweatshirts sweater pullover fleece',
    hat: 'hat hats headwear',
    beanie: 'beanie beanies toque knit',
    cap: 'cap caps baseball snapback trucker',
    color: 'color colors colour colours shade shades',
    material: 'material materials fabric cotton polyester made-of blend acrylic quality',
    care: 'care wash washing clean',
    made: 'handmade',
    flagship: 'flagship popular best bestseller favorite top',
    electrician: 'electrician electricians electric electrical sparky wireman',
    lineman: 'lineman linemen lineworker',
    welder: 'welder welders welding weld fabricator fabricators fabrication ironworker',
    hvac: 'hvac heating cooling refrigeration ac',
    mechanic: 'mechanic mechanics wrench plumber plumbers plumbing automotive',
    operator: 'operator operators equipment excavator excavation dozer bulldozer skid steer construction',
    western: 'western cowboy cowgirl horse horses rodeo ranch',
    gift: 'gift gifts present dad husband boyfriend birthday christmas',
    brand: 'brand story company',
    about: 'about who',
    contact: 'contact reach talk',
    email: 'email',
    human: 'human person someone',
    pay: 'pay payment payments paypal card credit debit apple google klarna afterpay venmo',
    discount: 'discount discounts code codes coupon promo sale deal deals off pack10',
    location: 'located location based store address-of where-are',
    buy: 'buy add cart checkout want need',
    restrict: 'restrict restricted restrictions banned exclude excluded sanctioned',
    range: 'carry sell sells stock offer lineup selection options',
    black: 'black', white: 'white', pink: 'pink', orange: 'orange', navy: 'navy blue', gray: 'gray grey',
    green: 'green', lilac: 'lilac purple', sandshell: 'sandshell tan beige sand', royal: 'royal', natural: 'natural cream'
  };
  var PHRASES = [
    [/\bhow long\b/g, ' time '], [/\bwhen will\b/g, ' time arrive '], [/\bt[\s-]?shirts?\b/g, ' tee '],
    [/\bwhere are\b/g, ' where-are '], [/\bmade of\b/g, ' made-of '], [/\bmoney back\b/g, ' refund '],
    [/\btrue to size\b/g, ' fit size '], [/\brun(s)? (big|large)\b/g, ' fit big '], [/\brun(s)? small\b/g, ' fit small '],
    [/\bx{2}l\b/g, ' 2xl '], [/\bx{3}l\b/g, ' 3xl '], [/\bdon'?t fit\b/g, ' fit exchange '], [/\bpack ?10\b/g, ' pack10 '], [/\b(don'?t|do not|can'?t|cannot|not|won'?t)( you| u| we)? ship\b/g, ' restrict ship '],
    [/\bskid steer\b/g, ' operator '], [/\bheavy equipment\b/g, ' operator ']
  ];
  var W = { electrician: 5, lineman: 5, welder: 5, hvac: 5, mechanic: 5, operator: 5, western: 5, location: 6, pay: 5, discount: 5,
    tee: 2, hoodie: 2, hat: 2, beanie: 2, cap: 2, canada: 3, australia: 3, uk: 3, europe: 3, buy: 1 };
  var COLORS = ['black', 'white', 'pink', 'orange', 'navy', 'gray', 'green', 'lilac', 'sandshell', 'royal', 'natural'];
  var TRADE_COL = { electrician: 'electricians-linemen', lineman: 'electricians-linemen', welder: 'welders-fabricators',
    hvac: 'hvac-mechanics', mechanic: 'hvac-mechanics', operator: 'heavy-equipment-excavation', western: 'western-free-spirit' };
  var TYPE_COL = { tee: 't-shirts', hoodie: 'hoodies-sweatshirts', hat: 'hats', beanie: 'hats', cap: 'hats' };
  var EXPAND = { beanie: ['hat'], cap: ['hat'] };
  var STOP = ' whats wheres hows im its u ur pls a an the i we you your my me do does is are can could would will to of for in on at and or with it this that what how any have has be get there please hi hey hello thanks so just like one ';
  var SIZE_ORDER = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', 'one size'];
  var NUM = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];

  var MAP = {}, VOCAB = [];
  Object.keys(SYN).forEach(function (c) {
    SYN[c].split(' ').concat([c]).forEach(function (w) { if (!MAP[w]) MAP[w] = c; VOCAB.push(w); });
  });
  /* Damerau (optimal string alignment) distance, so "shpiping" and "hodie" still match */
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) {
      var c = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  }
  /* brand and design words that must never be fuzzy-matched into an intent (pack is not back) */
  var PLAIN = ' pack grit collar blue crew earned given wolf eagle iron cross globe chains respect craft ride current hold edge cool earth grade future below lightning stride steel spirit ';
  var CANON_CACHE = {};
  function canon(w) {
    if (w in CANON_CACHE) return CANON_CACHE[w];
    var r = MAP[w] || null;
    if (!r && PLAIN.indexOf(' ' + w + ' ') > -1) return (CANON_CACHE[w] = null);
    if (!r) { var st = w.replace(/(ing|ed|es|s)$/, ''); if (st.length > 2 && MAP[st]) r = MAP[st]; }
    if (!r && w.length >= 4) {
      var bd = w.length >= 7 ? 2 : 1;
      for (var k = 0; k < VOCAB.length; k++) {
        var v = VOCAB[k];
        if (v.length < 4) continue;
        var dd = lev(w, v);
        /* short words (4 letters) only fuzzy-match a swapped pair: "sihp" yes, "safe" to "sale" no */
        if (dd && w.length < 5 && w.split('').sort().join('') !== v.split('').sort().join('')) continue;
        if (dd <= bd) { bd = dd; r = MAP[v]; if (dd === 0) break; }
      }
    }
    CANON_CACHE[w] = r;
    return r;
  }
  function norm(text) {
    var s = ' ' + String(text || '').toLowerCase().replace(/[\u2019']/g, "'") + ' ';
    PHRASES.forEach(function (p) { s = s.replace(p[0], p[1]); });
    return s;
  }
  function tokens(text) {
    var raw = norm(text).replace(/[^a-z0-9\-\s]/g, ' ').split(/\s+/), out = [], seen = {};
    raw.forEach(function (w) {
      if (!w || STOP.indexOf(' ' + w + ' ') > -1) return;
      var c = canon(w);
      if (!c) return;
      [c].concat(EXPAND[c] || []).forEach(function (x) { if (!seen[x]) { seen[x] = 1; out.push(x); } });
    });
    return out;
  }
  function index(FAQ) {
    FAQ.forEach(function (f) {
      f.K = {}; String(f.k || '').split(' ').forEach(function (k) { if (k) f.K[k] = 1; });
      f.Q = {}; tokens(f.q).forEach(function (k) { f.Q[k] = 1; });
    });
    return FAQ;
  }
  function rank(FAQ, text) {
    var tk = tokens(text);
    var res = FAQ.map(function (f, i) {
      var s = 0, hit = 0;
      tk.forEach(function (t) {
        var w = W[t] || 4;
        if (f.K[t]) { s += w; hit++; } else if (f.Q[t]) { s += w * 0.5; hit++; }
      });
      if (hit && hit === Object.keys(f.K).length) s += 1; /* every key word matched: best fit */
      return { i: i, s: s };
    }).filter(function (r) { return r.s > 0; });
    res.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    return { tk: tk, res: res };
  }

  /* ---------- live catalog from /products.json ---------- */
  function cleanTitle(t) { return String(t || '').split(' | ')[0].trim(); }
  function kind(p) {
    var t = (p.title || '').toLowerCase(), ty = (p.product_type || '').toLowerCase();
    if (/beanie/.test(t)) return 'beanie';
    if (/\bcap\b|snapback|trucker/.test(t)) return 'cap';
    if (/hoodie|sweatshirt/.test(t) || /hoodie/.test(ty)) return 'hoodie';
    if (/hat/.test(ty)) return 'cap';
    return 'tee';
  }
  function sizeKey(v) { var i = SIZE_ORDER.indexOf(String(v).toLowerCase()); return i < 0 ? 99 : i; }
  function stripTags(s) { return String(s || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim(); }
  function parseChart(html) {
    var m = String(html || '').match(/<table[^>]*id=["']?size-guide[^>]*>([\s\S]*?)<\/table>/i) || String(html || '').match(/<table[^>]*>([\s\S]*?)<\/table>/i);
    if (!m) return null;
    var rows = [];
    (m[1].match(/<tr[\s\S]*?<\/tr>/gi) || []).forEach(function (tr) {
      var cells = (tr.match(/<t[hd][^>]*>[\s\S]*?<\/t[hd]>/gi) || []).map(stripTags);
      if (cells.length) rows.push(cells);
    });
    return rows.length > 1 ? rows : null;
  }
  function imgUrl(src, w) {
    if (!src) return null;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }
  function normalize(json) {
    return ((json && json.products) || []).map(function (p) {
      var opts = (p.options || []).map(function (o) { return { n: o.name, v: o.values.slice() }; });
      var prices = (p.variants || []).map(function (v) { return Math.round(parseFloat(v.price) * 100); });
      var imgs = {};
      (p.images || []).forEach(function (im) { imgs[im.id] = im.src; });
      return {
        h: p.handle, t: cleanTitle(p.title), k: kind(p), u: '/products/' + p.handle,
        tags: (p.tags || []).map(function (x) { return String(x).toLowerCase(); }),
        img: imgUrl(p.images && p.images[0] && p.images[0].src, 200),
        min: Math.min.apply(null, prices), max: Math.max.apply(null, prices),
        o: opts,
        v: (p.variants || []).map(function (v) {
          return { id: v.id, a: !!v.available, p: Math.round(parseFloat(v.price) * 100), o: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }),
            img: v.featured_image ? imgUrl(v.featured_image.src, 200) : null };
        }),
        av: (p.variants || []).some(function (v) { return v.available; }),
        chart: parseChart(p.body_html),
        created: p.created_at || ''
      };
    });
  }
  function optVals(p, name) {
    for (var i = 0; i < p.o.length; i++) if (p.o[i].n.toLowerCase() === name) return p.o[i].v;
    return [];
  }
  function union(list, name) {
    var out = [];
    list.forEach(function (p) { optVals(p, name).forEach(function (v) { if (out.indexOf(v) < 0) out.push(v); }); });
    return out;
  }
  function join(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function money(c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function range(list) {
    if (!list.length) return '';
    var lo = Math.min.apply(null, list.map(function (p) { return p.min; })), hi = Math.max.apply(null, list.map(function (p) { return p.max; }));
    return lo === hi ? money(lo) : money(lo) + ' to ' + money(hi);
  }
  function chartText(p) {
    if (!p.chart) return '';
    var head = p.chart[0], parts = [];
    p.chart.slice(1).forEach(function (r) {
      var m = r[0].match(/^(.*?),\s*(in|inch|inches|cm)$/i), unit = m ? ' ' + m[2] : '', label = (m ? m[1] : r[0]).toLowerCase();
      if (head.length === 2) parts.push(label + ' ' + r[1] + unit);
      else parts.push(label + ': ' + r.slice(1).map(function (c, i) { return (head[i + 1] || '') + ' ' + c + unit; }).join(', '));
    });
    return parts.join('; ');
  }
  function promoActive(promo, now) {
    return !!(promo && promo.ends && (now == null ? Date.now() : now) < Date.parse(promo.ends) &&
      (!promo.starts || (now == null ? Date.now() : now) >= Date.parse(promo.starts)));
  }
  function promoLine(promo, now) {
    if (!promoActive(promo, now)) return '';
    return promo.name + ' is on: ' + promo.pct + '% off orders of ' + money(promo.min * 100) + ' or more through ' + promo.endLabel +
      '. It comes off automatically at checkout, no code needed.';
  }
  function sameSet(a, b) { return a.length === b.length && a.every(function (x) { return b.indexOf(x) > -1; }); }
  function line(p) { return p.t.replace(/\s+Embroidered.*$/i, '').replace(/\s+(Patch Cap|Knit Beanie|Cap|Beanie)$/i, ''); }
  function hatsSorted(cat) {
    var hats = cat.filter(function (p) { return p.k === 'cap' || p.k === 'beanie'; });
    var newest = {};
    hats.forEach(function (p) { var l = line(p); if (!newest[l] || p.created > newest[l]) newest[l] = p.created; });
    return hats.sort(function (a, b) {
      var la = line(a), lb = line(b);
      if (la !== lb) return newest[la] < newest[lb] ? 1 : -1;
      return a.k === b.k ? 0 : a.k === 'cap' ? -1 : 1;
    });
  }
  function colorSentence(list, noun, plural) {
    if (!list.length) return '';
    var cols = list.map(function (p) { return optVals(p, 'color'); });
    if (cols.every(function (c) { return sameSet(c, cols[0]); })) {
      var who = list.length === 1 ? 'The ' + list[0].t : list.length === 2 ? 'Both ' + plural + ', ' + line(list[0]) + ' and ' + line(list[1]) + ',' :
        'All ' + (NUM[list.length] || list.length) + ' ' + plural;
      return who + (list.length === 1 ? ' comes in ' : ' come in ') + join(cols[0]) + '.';
    }
    return list.map(function (p, i) { return 'The ' + p.t + ' comes in ' + join(cols[i]) + '.'; }).join(' ');
  }
  function sizesOf(list) { return union(list, 'size').sort(function (a, b) { return sizeKey(a) - sizeKey(b); }); }
  function sizeLine(list) {
    var all = sizesOf(list);
    if (!all.length) return 'a range of sizes (pick yours on the product page)';
    var varies = list.some(function (p) { return !sameSet(optVals(p, 'size'), all); });
    return join(all) + (varies ? ' (sizes vary by design, the product page shows what each one has)' : '');
  }
  function chartLine(list, noun) {
    var withChart = list.filter(function (p) { return p.chart; });
    if (withChart.length) return 'Some ' + noun + ' pages have a size guide. Ask me about one by name and I\u2019ll pull it up.';
    return 'We don\u2019t have a measurement chart posted for our ' + noun + ' yet, so the best move is to compare with a ' +
      (noun === 'hoodies' ? 'hoodie' : 'tee') + ' you own that fits well. Not sure? Send us your question and we\u2019ll help before you order.';
  }
  function facts(cat, promo, now) {
    var F = {};
    var tees = cat.filter(function (p) { return p.k === 'tee'; }), hoods = cat.filter(function (p) { return p.k === 'hoodie'; });
    var hats = hatsSorted(cat), caps = hats.filter(function (p) { return p.k === 'cap'; }), beanies = hats.filter(function (p) { return p.k === 'beanie'; });
    F.tee_sizes = sizeLine(tees); F.hoodie_sizes = sizeLine(hoods);
    F.tee_chart = chartLine(tees, 'tees'); F.hoodie_chart = chartLine(hoods, 'hoodies');
    F.fit_note = tees.concat(hoods).some(function (p) { return p.chart; }) ? 'Check the size guide on the product page before you order.' :
      'We don\u2019t have measurement charts posted for tees and hoodies yet, so compare with a piece you own that fits well.';
    F.tee_colors = join(union(tees, 'color')) || 'several colors'; F.hoodie_colors = join(union(hoods, 'color')) || 'several colors';
    F.tee_price = range(tees); F.hoodie_price = range(hoods);
    var capCharts = caps.filter(function (p) { return p.chart; });
    F.cap_crown = capCharts.length ? '. The ' + capCharts[0].t + ' size guide lists ' + chartText(capCharts[0]) : '';
    F.hat_colors = (colorSentence(caps, 'cap', 'caps') + ' ' + colorSentence(beanies, 'beanie', 'knit beanies')).trim();
    var hp = range(hats), same = hats.length && hats.every(function (p) { return p.min === hats[0].min && p.max === hats[0].min; });
    F.hat_list = hats.length ? 'We carry ' + (NUM[hats.length] || hats.length) + ' hat' + (hats.length > 1 ? 's' : '') +
      (same ? ', ' + hp + ' each' : ', ' + hp) + ': ' + join(hats.map(function (p) { return 'the ' + p.t; })) + '.' : 'Our hats and beanies are in the hats collection.';
    F.hat_price_line = hats.length ? (same ? 'Caps and beanies are ' + hp + '.' : 'Caps and beanies run ' + hp + '.') : '';
    F.promo = promoLine(promo, now);
    F.promo_or_none = F.promo ? 'Yes! ' + F.promo + ' Want to see the lineup?' :
      'No codes right now. Drop your email in the chat and we\u2019ll let you know about new drops first. Meanwhile, here\u2019s the lineup:';
    return F;
  }
  function fill(text, F) {
    return String(text).replace(/\[\[(\w+)\]\]/g, function (m, k) { return F && F[k] != null ? F[k] : ''; })
      .replace(/\s+([.,])/g, '$1').replace(/\.\./g, '.').replace(/\s{2,}/g, ' ').trim();
  }
  function findProducts(cat, tk, text, inTrade) {
    var words = norm(text).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 3 && STOP.indexOf(' ' + w + ' ') < 0; });
    var wantTypes = tk.filter(function (t) { return TYPE_COL[t]; });
    if (wantTypes.some(function (t) { return t === 'beanie' || t === 'cap'; })) wantTypes = wantTypes.filter(function (t) { return t !== 'hat'; });
    var scored = cat.map(function (p) {
      var s = 0, title = p.t.toLowerCase(), hay = title + ' ' + p.tags.join(' '), cols = optVals(p, 'color').join(' ').toLowerCase();
      if (wantTypes.length) {
        var ok = wantTypes.some(function (t) { return t === p.k || (t === 'hat' && (p.k === 'cap' || p.k === 'beanie')); });
        s += ok ? 4 : -6;
      }
      tk.forEach(function (t) {
        if (TRADE_COL[t]) {
          if (inTrade && inTrade[TRADE_COL[t]] && inTrade[TRADE_COL[t]].indexOf(p.h) > -1) s += 6;
          else if (hay.indexOf(t) > -1) s += 3;
        }
        if (COLORS.indexOf(t) > -1 && cols.indexOf(t) > -1) s += 2;
        if (t === 'flagship' && p.tags.indexOf('flagship') > -1) s += 3;
        if (t === 'gift' && /gift/.test(hay)) s += 1;
      });
      var named = 0;
      words.forEach(function (w) {
        if (title.indexOf(w) > -1) { s += 2; if (!canonWord(w)) named++; }
        else if (title.split(/\W+/).some(function (x) { return x.length > 4 && lev(x, w) <= 1; })) s += 1.5;
        else if (hay.indexOf(w) > -1) s += 0.5;
      });
      if (!p.av) s -= 3;
      if (p.tags.indexOf('flagship') > -1 || p.tags.indexOf('new') > -1) s += 0.25;
      return { p: p, s: s, n: named };
    }).filter(function (r) { return r.s > 2.5; });
    /* if the shopper named a design ("wolf hoodie"), only show designs that match the name */
    if (scored.some(function (r) { return r.n; })) scored = scored.filter(function (r) { return r.n; });
    scored.sort(function (a, b) { return b.s - a.s; });
    return scored.slice(0, 3).map(function (r) { return r.p; });
  }
  function productIntent(tk) {
    return tk.some(function (t) { return TYPE_COL[t] || TRADE_COL[t] || COLORS.indexOf(t) > -1 || t === 'flagship' || t === 'buy' || t === 'gift'; });
  }
  function pickVariant(p, tk, text) {
    var avail = p.v.filter(function (v) { return v.a; });
    if (!avail.length) return null;
    var low = norm(text), cIdx = -1, sIdx = -1;
    p.o.forEach(function (o, i) { if (/colou?r/i.test(o.n)) cIdx = i; if (/size/i.test(o.n)) sIdx = i; });
    var best = avail[0], bs = -1;
    avail.forEach(function (v) {
      var s = 0;
      if (cIdx > -1 && tk.some(function (t) { return COLORS.indexOf(t) > -1 && v.o[cIdx].toLowerCase().indexOf(t) === 0; })) s += 2;
      if (sIdx > -1 && new RegExp('(^|\\s)' + v.o[sIdx].toLowerCase().replace(/[^a-z0-9 ]/g, '') + '(\\s|$)').test(low)) s += 2;
      if (sIdx > -1 && s < 2 && v.o[sIdx] === 'L') s += 0.1; /* nudge default size to L when unknown */
      if (s > bs) { bs = s; best = v; }
    });
    return best;
  }
  function withUtm(u) {
    if (!u || /^(mailto|tel):/.test(u) || /utm_source=/.test(u)) return u;
    var h = u.split('#');
    return h[0] + (h[0].indexOf('?') > -1 ? '&' : '?') + 'utm_source=bcp-chat' + (h[1] ? '#' + h[1] : '');
  }
  var canonWord = canon;
  var Core = { tokens: tokens, canon: canon, lev: lev, index: index, rank: rank, normalize: normalize, parseChart: parseChart, chartText: chartText,
    facts: facts, fill: fill, findProducts: findProducts, productIntent: productIntent, pickVariant: pickVariant, withUtm: withUtm,
    promoActive: promoActive, promoLine: promoLine, money: money, join: join, sizesOf: sizesOf, optVals: optVals, TRADE_COL: TRADE_COL, TYPE_COL: TYPE_COL, COLORS: COLORS };
  if (typeof module !== 'undefined' && module.exports) { module.exports = Core; return; }

  /* =================== UI =================== */
  var doc = G.document, dataEl = doc.getElementById('bcp-chat-data'), root = doc.getElementById('bcp-chat-root');
  if (!dataEl || !root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var FAQ = index(D.faq || []), COLS = D.collections || [], PROMO = D.promo || null;
  var KEY = 'bcpChat.v2', CAT_KEY = 'bcpChat.cat.v2', EMAIL_RE = /[^\s@]+@[^\s@]+\.[^\s@]+/;
  var ROOT = (D.root || '/').replace(/\/$/, '');
  var S = store(G.localStorage, KEY);
  S.log = S.log || []; S.n = S.n || 0;
  function store(st, k) { try { return JSON.parse(st.getItem(k)) || {}; } catch (e) { return {}; } }
  function save() {
    try { if (S.log.length > 40) S.log = S.log.slice(-40); G.localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {}
  }
  function sget(k) { try { return G.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { G.sessionStorage.setItem(k, v); } catch (e) {} }

  /* live catalog: fetched once per visit, only when the chat is used */
  var CAT = null, FACTS = null, catP = null, TRADE = {};
  function catalog() {
    if (catP) return catP;
    var cached = sget(CAT_KEY);
    if (cached) { try { var c = JSON.parse(cached); if (Date.now() - c.at < 15 * 60 * 1000) { setCat(c.cat); return (catP = Promise.resolve(CAT)); } } catch (e) {} }
    if (!G.fetch) return (catP = Promise.resolve(null));
    var live = fetch(ROOT + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) { var c = normalize(j); setCat(c); sset(CAT_KEY, JSON.stringify({ at: Date.now(), cat: c })); return CAT; })
      .catch(function () { catP = null; return null; });
    var timeout = new Promise(function (res) { setTimeout(function () { res(CAT); }, 4000); });
    return (catP = Promise.race([live, timeout]));
  }
  function setCat(c) { CAT = c; FACTS = facts(c, PROMO); }
  function getFacts() { return FACTS || facts([], PROMO); }
  function tradeHandles(col) {
    if (TRADE[col]) return Promise.resolve(TRADE[col]);
    return fetch(ROOT + '/collections/' + col + '/products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { TRADE[col] = (j.products || []).map(function (p) { return p.handle; }); return TRADE[col]; })
      .catch(function () { return []; });
  }
  function current() {
    var h = root.dataset.product;
    if (!h || !CAT) return null;
    for (var i = 0; i < CAT.length; i++) if (CAT[i].h === h) return CAT[i];
    return null;
  }

  /* ---------- DOM helpers ---------- */
  function el(tag, attrs, kids) {
    var n = doc.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'on') Object.keys(attrs.on).forEach(function (ev) { n.addEventListener(ev, attrs.on[ev]); });
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? doc.createTextNode(c) : c); });
    return n;
  }
  function richText(str) {
    var frag = doc.createDocumentFragment();
    String(str).split(/([\w.+-]+@[\w-]+\.[\w.]+)/).forEach(function (part, i) {
      frag.appendChild(i % 2 ? el('a', { href: 'mailto:' + part, text: part }) : doc.createTextNode(part));
    });
    return frag;
  }
  var RM = G.matchMedia && G.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function avatar(cls) {
    var src = D.avatar || D.icon;
    return el('span', { class: 'bcp-chat__av ' + (cls || ''), 'aria-hidden': 'true' }, [
      src ? el('img', { src: src, alt: '', width: '48', height: '48', class: 'bcp-chat__icon' + (D.avatar ? '' : ' is-fav') }) : el('b', { text: 'BCP' }),
      el('span', { class: 'bcp-chat__dot' })]);
  }
  function dots() { return el('span', { class: 'bcp-chat__dots', 'aria-hidden': 'true' }, [el('i'), el('i'), el('i')]); }
  var launcher = el('button', { type: 'button', class: 'bcp-chat__launcher', 'aria-expanded': 'false', 'aria-controls': 'bcp-chat-panel', 'aria-label': 'Ask the Pack. Open chat' },
    [avatar('bcp-chat__av--ring'), el('span', { class: 'bcp-chat__launch-text' }, [el('strong', { text: 'Ask the Pack' }), el('small', { text: 'Questions? Ask away' })])]);
  var log = el('div', { class: 'bcp-chat__log', role: 'log', 'aria-live': 'polite', 'aria-relevant': 'additions', tabindex: '0' });
  var input = el('input', { type: 'text', class: 'bcp-chat__input', placeholder: 'Ask about shipping, sizes, colors\u2026', 'aria-label': 'Type your question', maxlength: '300', autocomplete: 'off', enterkeyhint: 'send' });
  var form = el('form', { class: 'bcp-chat__composer', novalidate: '' }, [input, el('button', { type: 'submit', class: 'bcp-chat__send', 'aria-label': 'Send', text: 'Send' })]);
  var minBtn = el('button', { type: 'button', class: 'bcp-chat__min', 'aria-label': 'Minimize chat', text: '\u00d7' });
  var resetBtn = el('button', { type: 'button', class: 'bcp-chat__reset', 'aria-label': 'Start over', text: '\u21ba' });
  var promoBar = Core.promoActive(PROMO) ? el('div', { class: 'bcp-chat__promo', text: '\ud83d\udd25 ' + PROMO.name + ': ' + PROMO.pct + '% off $' + PROMO.min + '+ through ' + PROMO.endLabel + ', applied at checkout' }) : null;
  var panel = el('div', { id: 'bcp-chat-panel', class: 'bcp-chat__panel', role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'bcp-chat-title', hidden: '' }, [
    el('div', { class: 'bcp-chat__head' }, [avatar(),
      el('div', { class: 'bcp-chat__titles' }, [el('strong', { id: 'bcp-chat-title', text: 'Ask the Pack' }),
        el('span', {}, [el('i', { class: 'bcp-chat__live', 'aria-hidden': 'true' }), 'Instant answers, 24/7'])]),
      resetBtn, minBtn]),
    promoBar, log, form]);
  var nudge = null;
  log.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || /^(mailto|tel):/.test(a.getAttribute('href'))) return;
    S.open = 0; save(); panel.hidden = true; launcher.setAttribute('aria-expanded', 'false'); launcher.classList.remove('is-open');
  });
  root.appendChild(panel); root.appendChild(launcher); root.hidden = false;
  if (root.dataset.template === 'product') root.classList.add('bcp-chat--product');

  function scroll() { log.scrollTop = log.scrollHeight; }
  function bubble(who, nodes) { var b = el('div', { class: 'bcp-chat__msg bcp-chat__msg--' + who }, nodes); log.appendChild(b); scroll(); return b; }
  function chips(list) {
    var wrap = el('div', { class: 'bcp-chat__chips' });
    list.forEach(function (c) {
      wrap.appendChild(el('button', { type: 'button', class: 'bcp-chat__chip', text: c.t, on: { click: function () { c.f ? c.f() : ask(c.q || c.t, c.i, c.r); } } }));
    });
    log.appendChild(wrap); scroll(); return wrap;
  }
  var LABEL = { all: 'Shop the pack', 't-shirts': 'Shop tees', 'hoodies-sweatshirts': 'Shop hoodies', hats: 'Shop hats & beanies', 'new-arrivals': 'See new arrivals', flagship: 'Shop flagship gear' };
  function colTitle(h) { for (var i = 0; i < COLS.length; i++) if (COLS[i].h === h) return COLS[i].t; return null; }
  function cta(url) {
    var h = (String(url || '').match(/\/collections\/([^/?#]+)/) || [])[1] || 'all';
    if (h !== 'all' && !colTitle(h)) h = 'all';
    return { u: ROOT + '/collections/' + h, t: LABEL[h] || ('Shop ' + (colTitle(h) || 'the pack')) };
  }
  function ctaBtn(c) { return el('a', { class: 'bcp-chat__cta', href: withUtm(c.u), text: c.t + ' \u2192' }); }
  function persist(entry) { S.log.push(entry); save(); }

  /* ---------- product cards: image, price, options, add to cart ---------- */
  function card(p, tk, text) {
    var v = pickVariant(p, tk, text || ''), selects = [];
    var url = ROOT + p.u;
    var img = el('img', { src: (v && v.img) || p.img || '', alt: p.t, loading: 'lazy', width: '72', height: '72' });
    var price = el('span', { class: 'bcp-chat__price' });
    var addBtn = el('button', { type: 'button', class: 'bcp-chat__btn bcp-chat__btn--alt', text: 'Add to cart' });
    function sel() {
      var vals = selects.map(function (s) { return s.value; });
      var m = p.v.filter(function (x) { return selects.every(function (s, i) { return x.o[s.dataset.i] === vals[i]; }); })[0];
      v = m || null;
      var ok = v && v.a;
      addBtn.disabled = !ok; addBtn.textContent = ok ? 'Add to cart' : 'Sold out';
      price.textContent = v ? money(v.p) : (p.min === p.max ? money(p.min) : 'From ' + money(p.min));
      if (v && v.img) img.src = v.img;
    }
    p.o.forEach(function (o, i) {
      if (o.v.length < 2) return;
      var s = el('select', { class: 'bcp-chat__sel', 'aria-label': o.n + ' for ' + p.t, 'data-i': String(i) });
      o.v.forEach(function (val) {
        var any = p.v.some(function (x) { return x.o[i] === val && x.a; });
        var opt = el('option', { value: val, text: val + (any ? '' : ' (sold out)') });
        if (v && v.o[i] === val) opt.selected = true;
        s.appendChild(opt);
      });
      s.addEventListener('change', sel);
      selects.push(s);
    });
    addBtn.addEventListener('click', function () { if (v && v.a) addToCart(v.id, addBtn, p); });
    sel();
    if (!p.av) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
    return el('div', { class: 'bcp-chat__card' }, [
      el('a', { href: withUtm(url), class: 'bcp-chat__card-img', tabindex: '-1', 'aria-hidden': 'true' }, [img]),
      el('div', { class: 'bcp-chat__card-body' }, [el('a', { href: withUtm(url), class: 'bcp-chat__card-title', text: p.t }), price,
        selects.length ? el('div', { class: 'bcp-chat__sels' }, selects) : null,
        el('div', { class: 'bcp-chat__card-btns' }, [addBtn, el('a', { class: 'bcp-chat__btn', href: withUtm(url), text: 'Details' })])])]);
  }
  function addToCart(id, btn, p) {
    btn.disabled = true; btn.textContent = 'Adding\u2026';
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch((D.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        /* tag the cart so chat-driven orders show up on the order (Additional details) */
        return fetch((D.cartUrl || '/cart') + '/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: { chat_used: 'yes' } }) }).catch(function () {});
      })
      .then(function () {
        btn.textContent = 'Added \u2713'; btn.disabled = false;
        var deal = Core.promoActive(PROMO) ? ' ' + PROMO.pct + '% off comes off automatically at checkout on orders of $' + PROMO.min + '+.' : '';
        bubble('bot', ['Added to your cart.' + deal + ' ', el('a', { href: withUtm(D.cartUrl || '/cart'), text: 'View cart & check out \u2192' })]);
        persist({ t: 'add', h: p.h });
        doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; bubble('bot', ['Couldn\u2019t add that one. Tap Details to pick your options on the product page.']); });
  }
  function showProducts(list, tk, text) {
    if (!list.length) return;
    var wrap = el('div', { class: 'bcp-chat__cards' });
    list.forEach(function (p) { wrap.appendChild(card(p, tk, text)); });
    log.appendChild(wrap); scroll();
  }
  function sizeTable(p) {
    var t = el('table', { class: 'bcp-chat__table' });
    p.chart.forEach(function (r, i) { t.appendChild(el('tr', {}, r.map(function (c) { return el(i ? 'td' : 'th', { text: c }); }))); });
    return t;
  }

  /* ---------- conversation ---------- */
  function welcome(store) {
    var w = D.welcome + (Core.promoActive(PROMO) ? ' ' + Core.promoLine(PROMO) : '');
    bubble('bot', [richText(w)]); mainChips();
    if (store !== false) persist({ w: 1 });
  }
  function mainChips() {
    var list = [{ t: 'Shipping', i: 0, r: [2, 4] }, { t: 'Sizes', q: 'What sizes do you have?', f: sizeHelp }, { t: 'Colors', i: 21, r: [22, 23] },
      { t: 'Returns', i: 12, r: [13, 15] }, { t: 'Shop by trade', f: trades }, { t: 'Hats & beanies', i: 29, r: [23, 25] }];
    if (Core.promoActive(PROMO)) list.unshift({ t: '\ud83d\udd25 Launch deal', i: 39 });
    chips(list);
  }
  function trades(noStore) {
    if (noStore !== true) { bubble('user', ['Shop by trade']); persist({ u: 'Shop by trade' }); persist({ tr: 1 }); typing(tradeChips); } else tradeChips();
  }
  function tradeChips() {
    bubble('bot', ['Pick your trade and I\u2019ll pull up the right gear:']);
    chips([{ t: 'Electricians & linemen', q: 'electrician shirts', i: 30 }, { t: 'Welders', q: 'welder shirts', i: 31 }, { t: 'HVAC & mechanics', q: 'hvac mechanic shirts', i: 32 },
      { t: 'Heavy equipment', q: 'heavy equipment shirts', i: 33 }, { t: 'Western', q: 'western shirts', i: 34 }, { t: 'Every trade', q: 'gift for any trade', i: 35 }]);
  }
  function showFaq(i, related, store) {
    var f = FAQ[i];
    var b = bubble('bot', [richText(fill(f.a, getFacts())), el('div', { class: 'bcp-chat__ctas' }, [ctaBtn(cta(f.l))])]);
    if (related && related.length) {
      log.appendChild(el('div', { class: 'bcp-chat__related', text: 'Related:' }));
      chips(related.map(function (j) { return { t: FAQ[j].q, i: j }; }));
    }
    if (store !== false) persist({ f: i, r: related || [] });
    return b;
  }
  function sizeHelp(text) {
    text = typeof text === 'string' ? text : 'What sizes do you have?';
    bubble('user', [text]); persist({ u: text });
    typing(function () { catalog().then(function () { answerSize(text, tokens(text)); }); });
  }
  function answerSize(text, tk) {
    var p = current(), F = getFacts();
    if (!p && CAT) { var named = findProducts(CAT, tk, text); if (named.length && namesIt(named[0], text)) p = named[0]; }
    if (p) {
      var sizes = sizesOf([p]), nodes = [];
      var msg = sizes.length && !(sizes.length === 1 && /one size/i.test(sizes[0])) ? 'The ' + p.t + ' comes in ' + join(sizes) + '.' : 'The ' + p.t + ' is one size.';
      nodes.push(msg + ' ');
      if (p.chart) { nodes.push('Here\u2019s its size guide:'); nodes.push(sizeTable(p)); }
      else if (p.k === 'tee' || p.k === 'hoodie') nodes.push('We don\u2019t have a measurement chart posted for this one yet. Compare with a ' + (p.k === 'tee' ? 'tee' : 'hoodie') + ' you own that fits well, or send us your question and we\u2019ll help before you order. Since every piece is made to order, we can\u2019t exchange sizes.');
      bubble('bot', nodes); persist({ f: 17 });
      showProducts([p], tk, text);
      return;
    }
    var want = tk.indexOf('hoodie') > -1 ? 18 : (tk.indexOf('hat') > -1 ? 19 : 17);
    showFaq(want, want === 17 ? [18, 19] : [17, 20]);
  }
  /* true when the shopper typed a distinctive word from this product's name (not just "hoodie" or "black") */
  function namesIt(p, text) {
    var said = ' ' + norm(text).replace(/[^a-z0-9 ]/g, ' ') + ' ';
    return p.t.toLowerCase().split(/[^a-z0-9]+/).some(function (w) {
      return w.length > 3 && !/^(graphic|embroidered|patch|knit|blue|collar|unisex)$/.test(w) && !canonWord(w) && said.indexOf(' ' + w + ' ') > -1;
    });
  }
  function ask(text, forced, rel) {
    text = String(text || '').trim();
    if (!text) return;
    bubble('user', [text]); persist({ u: text });
    typing(function () { catalog().then(function () { answer(text, forced, rel); }); });
  }
  function typing(cb) {
    var t = el('div', { class: 'bcp-chat__msg bcp-chat__msg--bot bcp-chat__typing', role: 'status', 'aria-label': 'Ask the Pack is typing' }, [dots()]);
    log.appendChild(t); scroll();
    setTimeout(function () { t.remove(); cb(); }, RM ? 0 : 300 + Math.round(Math.random() * 250));
  }
  function answer(text, forced, rel) {
    if (EMAIL_RE.test(text) && !S.email) { submitLead(text.match(EMAIL_RE)[0]); return; }
    var r = rank(FAQ, text), tk = r.tk;
    if (forced == null && (tk.indexOf('size') > -1 || tk.indexOf('fit') > -1) && !tk.some(function (t) { return /return|exchange|refund/.test(t); })) { answerSize(text, tk); bump(true); return; }
    var top = forced != null ? { i: forced, s: 99 } : r.res[0];
    var related = forced != null ? (rel || []) : r.res.filter(function (x) { return !top || x.i !== top.i; }).slice(0, 2).map(function (x) { return x.i; });
    var confident = top && top.s >= 4;
    if (confident) showFaq(top.i, related);
    var wantProducts = productIntent(tk);
    if (wantProducts) {
      var trade = tk.filter(function (t) { return TRADE_COL[t]; })[0];
      var go = function (inTrade) {
        var local = CAT ? findProducts(CAT, tk, text, inTrade) : [];
        if (local.length) { showProducts(local, tk, text); persist({ p: text }); }
        else if (!confident) noProducts(tk);
      };
      if (trade && CAT) { tradeHandles(TRADE_COL[trade]).then(function (hs) { var m = {}; m[TRADE_COL[trade]] = hs; go(m); }); } else go();
    }
    if (!confident && !wantProducts) fallback(text);
    bump(confident || wantProducts);
  }
  function bump(ok) {
    if (ok) S.n++;
    save();
    if (ok && S.n >= 2 && !S.email && !S.offered) { S.offered = 1; save(); setTimeout(offerLead, 500); }
  }
  function noProducts(tk) {
    var t = tk.filter(function (x) { return TRADE_COL[x] || TYPE_COL[x]; })[0];
    bubble('bot', ['Here\u2019s where you\u2019ll find it:', el('div', { class: 'bcp-chat__ctas' }, [ctaBtn(cta('/collections/' + (t ? (TRADE_COL[t] || TYPE_COL[t]) : 'all')))])]);
  }
  function fallback(text) {
    bubble('bot', ['Good question. I don\u2019t have a solid answer for that one, but the crew does. Send it over and we\u2019ll reply by email.',
      el('div', { class: 'bcp-chat__ctas' }, [ctaBtn(cta('/collections/all'))])]);
    questionForm(text); persist({ fb: text });
  }

  /* ---------- leads (native Shopify forms, no outside services) ---------- */
  function post(formEl) {
    return fetch(formEl.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(formEl), credentials: 'same-origin' })
      .then(function (r) { if (/\/challenge/.test(r.url)) { formEl.submit(); throw 'challenge'; } if (!r.ok) throw 'http'; return r; });
  }
  function offerLead() {
    if (S.email) return;
    var e = el('input', { type: 'email', required: '', placeholder: 'you@email.com', 'aria-label': 'Your email', autocomplete: 'email', class: 'bcp-chat__input' });
    var f = el('form', { class: 'bcp-chat__lead', novalidate: '' }, [e, el('button', { type: 'submit', class: 'bcp-chat__send', text: 'Keep me posted' })]);
    f.addEventListener('submit', function (ev) { ev.preventDefault(); submitLead(e.value, f); });
    bubble('bot', ['Want a heads up when new trade designs drop? Leave your email and you\u2019ll hear about them first.', f,
      el('small', { class: 'bcp-chat__fine', text: 'Emails from Blue Collar Pack Co. only. No spam, unsubscribe anytime.' })]);
  }
  function submitLead(email, f) {
    email = String(email).trim();
    if (!EMAIL_RE.test(email)) { bubble('bot', ['That email doesn\u2019t look right. Mind checking it?']); return; }
    var nf = doc.getElementById('bcp-chat-lead-form');
    if (!nf) return;
    nf.querySelector('[name="contact[email]"]').value = email;
    if (f) f.querySelector('button').disabled = true;
    post(nf).then(function () {
      S.email = email; save();
      bubble('bot', ['You\u2019re in the pack! \ud83d\udc4a We\u2019ll email ' + email + ' when new gear drops.']);
      persist({ t: 'lead' });
    }).catch(function (err) {
      if (err === 'challenge') return;
      if (f) f.querySelector('button').disabled = false;
      bubble('bot', ['Hmm, that didn\u2019t go through. Try again in a moment, or use the signup at the bottom of the page.']);
    });
  }
  function questionForm(q) {
    var e = el('input', { type: 'email', required: '', placeholder: 'you@email.com', 'aria-label': 'Your email', autocomplete: 'email', class: 'bcp-chat__input', value: S.email || '' });
    var t = el('textarea', { 'aria-label': 'Your question', class: 'bcp-chat__input', rows: '2', maxlength: '1000' });
    t.value = q || '';
    var f = el('form', { class: 'bcp-chat__lead', novalidate: '' }, [t, e, el('button', { type: 'submit', class: 'bcp-chat__send', text: 'Send us your question' })]);
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!EMAIL_RE.test(e.value)) { e.focus(); return; }
      var nf = doc.getElementById('bcp-chat-question-form');
      if (!nf) return;
      nf.querySelector('[name="contact[email]"]').value = e.value.trim();
      nf.querySelector('[name="contact[body]"]').value = 'Chat question (' + location.pathname + '): ' + t.value.trim();
      f.querySelector('button').disabled = true;
      post(nf).then(function () {
        S.email = S.email || e.value.trim(); save();
        bubble('bot', ['Thanks! Your question is on its way to the crew. We\u2019ll email you back as soon as we can.']);
        persist({ t: 'q' });
      }).catch(function (err) {
        if (err === 'challenge') return;
        f.querySelector('button').disabled = false;
        bubble('bot', ['That didn\u2019t send. You can email us directly at ' + D.email + '.']);
      });
    });
    bubble('bot', [f]);
  }

  /* ---------- restore, open/close, proactive greeting ---------- */
  function restore() {
    if (!S.log.length) { welcome(); return; }
    S.log.forEach(function (e) {
      if (e.w) bubble('bot', [richText(D.welcome)]);
      else if (e.u) bubble('user', [e.u]);
      else if (e.f != null && FAQ[e.f]) showFaq(e.f, [], false);
      else if (e.tr) trades(true);
      else if (e.fb) bubble('bot', ['We\u2019ll get back to you on that by email if you sent it over. Anything else?']);
      else if (e.t === 'lead') bubble('bot', ['You\u2019re in the pack! \ud83d\udc4a']);
      else if (e.t === 'q') bubble('bot', ['Thanks! Your question is on its way to the crew.']);
      else if (e.t === 'add') bubble('bot', ['Added to your cart. ', el('a', { href: withUtm(D.cartUrl || '/cart'), text: 'View cart \u2192' })]);
    });
    mainChips();
  }
  var built = false;
  function open() {
    catalog();
    if (!built) { built = true; catalog().then(restore); }
    panel.hidden = false; panel.classList.remove('is-in'); void panel.offsetWidth; panel.classList.add('is-in');
    launcher.setAttribute('aria-expanded', 'true'); launcher.classList.add('is-open');
    S.open = 1; save(); hideNudge();
    if (!('ontouchstart' in G)) setTimeout(function () { input.focus(); }, 30);
  }
  function close() { panel.hidden = true; launcher.setAttribute('aria-expanded', 'false'); launcher.classList.remove('is-open'); S.open = 0; save(); launcher.focus(); }
  launcher.addEventListener('click', function () { panel.hidden ? open() : close(); });
  minBtn.addEventListener('click', close);
  resetBtn.addEventListener('click', function () { S.log = []; S.n = 0; save(); log.textContent = ''; welcome(); });
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; ask(v); });
  function hideNudge() { if (nudge) { nudge.remove(); nudge = null; } }
  if (S.open && !G.matchMedia('(max-width: 600px)').matches) open();

  var tpl = root.dataset.template || '', NO_NUDGE = /^(cart|password|login|register|account|order|addresses|reset_password|activate_account|gift_card|404)$/;
  var GREET_KEY = 'bcpChat.greeted', greetTimer = null;
  function quick(t, i, r) { return function () { open(); if (i === 'trade') trades(); else if (i === 'size') sizeHelp(t); else ask(t, i, r); }; }
  function greet(why) {
    if (sget(GREET_KEY) || !panel.hidden || nudge) return;
    sset(GREET_KEY, why); clearTimeout(greetTimer); doc.removeEventListener('mouseout', exitIntent);
    var onProduct = tpl === 'product';
    var h = why === 'exit' ? 'Before you go \ud83d\udc4b got a question?' : (onProduct ? 'Hey \ud83d\udc4b questions about this one?' : 'Hey \ud83d\udc4b need a hand picking your gear?');
    var pline = Core.promoActive(PROMO) ? PROMO.pct + '% off orders $' + PROMO.min + '+ through ' + PROMO.endLabel + ', no code needed.' : 'Sizes, shipping, or your trade\u2019s shirt. Ask me anything.';
    var body = el('div', { class: 'bcp-chat__nudge-body' });
    nudge = el('div', { class: 'bcp-chat__nudge is-ready', role: 'dialog', 'aria-label': 'Ask the Pack' }, [
      el('button', { type: 'button', class: 'bcp-chat__nudge-x', 'aria-label': 'Dismiss', text: '\u00d7', on: { click: hideNudge } }),
      el('div', { class: 'bcp-chat__nudge-row' }, [avatar(), body])]);
    body.appendChild(el('button', { type: 'button', class: 'bcp-chat__nudge-h', text: h, on: { click: function () { open(); } } }));
    body.appendChild(el('p', { class: 'bcp-chat__nudge-p', text: pline }));
    var c = el('div', { class: 'bcp-chat__nudge-chips' });
    var opts = onProduct ? [['What size? \ud83d\udccf', 'What size should I get for this one?', 'size'], ['Shipping \ud83c\udf0e', 'Shipping', 0, [2, 4]], ['Returns', 'Returns', 12, [13, 15]]] :
      [['Shipping \ud83c\udf0e', 'Shipping', 0, [2, 4]], ['Sizes \ud83d\udccf', 'What sizes do you have?', 'size'], ['Shop my trade \ud83d\udd27', '', 'trade']];
    opts.forEach(function (x) { c.appendChild(el('button', { type: 'button', class: 'bcp-chat__chip', text: x[0], on: { click: quick(x[1], x[2], x[3]) } })); });
    body.appendChild(c);
    root.appendChild(nudge);
    catalog();
  }
  function exitIntent(e) { if (!e.relatedTarget && e.clientY <= 0) greet('exit'); }
  if (!sget(GREET_KEY) && !NO_NUDGE.test(tpl) && !S.open) {
    greetTimer = setTimeout(function () { greet('timer'); }, G.BCP_GREET_MS || 15000);
    if (G.matchMedia && G.matchMedia('(pointer: fine)').matches) setTimeout(function () { doc.addEventListener('mouseout', exitIntent); }, 4000);
  }
  G.BCPChat = { open: open, close: close, greet: greet, ask: function (q) { if (panel.hidden) open(); ask(q); },
    lead: function () { if (panel.hidden) open(); if (S.email) bubble('bot', ['You\u2019re already on the list \ud83d\udc4a']); else offerLead(); } };
})(typeof window !== 'undefined' ? window : this);
